import ServicosService from "@/views/RecursosPropriosQuestionarios/shared/services/ServicosService";
import QuestionarioService from "../../services/QuestionarioService";

import ValidacaoServicosPrestadosMixin from "@/views/RecursosPropriosQuestionarios/shared/mixins/validation/ValidacaoServicosPrestadosMixin";

export default {
  mixins: [
    ServicosService,
    ValidacaoServicosPrestadosMixin,
    QuestionarioService
  ],
  data() {
    return {
      servicos: [],
      outrosServicos: false,
      listaServicos: [],
      campoOutros: ""
    };
  },
  computed: {
    // pega o tipo de questionario do vuex store
    tipoQuest() {
      return this.$store.getters.getTipoQuestionario.tipoQuestionario;
    }
  },
  beforeMount() {
    this.preencheDadosServicos();
  },
  methods: {
    inicializarServicos() {
      return this.getServicos(
        this.$store.getters.getTipoQuestionario.tipoQuestionario
      ).then(({ data }) => {
        if (data) {
          this.listaServicos = data;
        }
      });
    },
    verificaNulo(texto) {
      return !!texto;
    },
    preparaDados(isUpdate) {
      const servicos = [...this.servicos];
      let objetoQuestionarioServicos = [];
      servicos.forEach(servico => {
        if (servico.tipoServico.includes("Outro")) {
          objetoQuestionarioServicos.push({
            idQuestionarioServico: "",
            tipoServico:
              typeof servico.tipoServico == "string"
                ? servico
                : servico.tipoServico,
            tipoServicoPublico: null,
            especialidadesOferecidas: null,
            numeroLeitosObservacao: null,
            outro: this.verificaNulo(this.campoOutros) ? this.campoOutros : ""
          });
        } else {
          objetoQuestionarioServicos.push({
            idQuestionarioServico:
              isUpdate && this.verificaNulo(servico.idQuestionarioServico)
                ? servico.idQuestionarioServico
                : "",
            tipoServico:
              typeof servico.tipoServico == "string"
                ? servico
                : servico.tipoServico,
            tipoServicoPublico: null,
            especialidadesOferecidas: null,
            numeroLeitosObservacao: null,
            outro: ""
          });
        }
      });
      return objetoQuestionarioServicos;
    },
    preencheDadosServicos() {
      const servicos = this.$store.getters.getPayloadServidor("servicos");
      this.servicos = [];
      if (servicos) {
        this.servicos = servicos.map(servico => {
          if (servico.tipoServico.tipoServico.includes("Outro")) {
            this.campoOutros = servico.outro;
          }
          return {
            id: servico.tipoServico.id,
            tipoServico: servico.tipoServico.tipoServico,
            idQuestionarioServico: servico.idQuestionarioServico,
            outro: servico.outro,
            tipoPublicoAlvo: null
          };
        });
      }
    }
  },
  watch: {
    servicos(servicos) {
      if (!servicos || servicos.length === 0) return;
      let arr = [];
      servicos.map(el => {
        arr.push(el.tipoServico);
      });
      arr.find(servico => {
        if (servico.includes("Outro")) {
          this.outrosServicos = true;
          return true;
        } else {
          this.outrosServicos = false;
          return false;
        }
      });
      this.chequeOutrosServicos(servicos);
    },
    // inicializa servicos quando servidor responde com o tipo de questionario
    tipoQuest(quest) {
      if (quest) {
        this.inicializarServicos();
      }
    }
  }
};
